import { useSelector } from 'react-redux';
import { useState } from 'react';
import { Tooltip } from '@mui/material';

import { If, MDBox, MDTypography } from '@components';
import { RootState } from '@store/store';
import FullPageLoader from '@components/FullPageLoader';

import { containsWhiteSpace, getUTCTime } from '@utils/common';

const ChartHeader = ({ isPreview = false }: { isPreview?: boolean }) => {
  const currentChartPreviewData = useSelector(
    (state: RootState) => state?.currentChartPreviewData
  );
  const [isShortTooltipOpen, setIsShortTooltipOpen] = useState(false);
  const [isTitleTooltipOpen, setIsTitleTooltipOpen] = useState(false);

  return (
    <>
      <If condition={!!currentChartPreviewData.chart_title}>
        <MDBox display='flex' flexDirection='column' py={2} pr={2}>
          <MDBox
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            flexWrap='wrap'
          >
            <MDBox display='flex' alignItems='center' columnGap={0.5}>
              <Tooltip
                title={
                  currentChartPreviewData?.chart_title &&
                  currentChartPreviewData?.chart_title.length <= 50
                    ? ''
                    : currentChartPreviewData?.chart_title || ''
                }
                placement='top'
                onMouseEnter={() => setIsTitleTooltipOpen(true)}
                onMouseLeave={() => setIsTitleTooltipOpen(false)}
                onClick={() => setIsTitleTooltipOpen(true)}
                open={isTitleTooltipOpen}
              >
                <MDTypography
                  variant='h3'
                  color='info'
                  textGradient
                  sx={{
                    whiteSpace: 'pre-wrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: { xs: 3, sm: 2 },
                    WebkitBoxOrient: 'vertical',
                    wordBreak: containsWhiteSpace(
                      currentChartPreviewData?.chart_title
                    )
                      ? 'normal'
                      : 'break-all'
                  }}
                >
                  {currentChartPreviewData?.chart_title || ''}
                </MDTypography>
              </Tooltip>
            </MDBox>
          </MDBox>
          {currentChartPreviewData?.chart_short_desc && (
            <Tooltip
              title={currentChartPreviewData?.chart_short_desc}
              onMouseEnter={() => setIsShortTooltipOpen(true)}
              onMouseLeave={() => setIsShortTooltipOpen(false)}
              onClick={() => setIsShortTooltipOpen(true)}
              open={isShortTooltipOpen}
              placement={isPreview ? 'bottom' : 'right'}
            >
              <MDTypography
                width='fit-content'
                variant='h5'
                color='info'
                sx={{
                  whiteSpace: 'pre-wrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitLineClamp: 5,
                  WebkitBoxOrient: 'vertical',
                  wordBreak: 'break-all'
                }}
              >
                {currentChartPreviewData?.chart_short_desc || ''}
              </MDTypography>
            </Tooltip>
          )}

          <MDTypography width='fit-content' variant='h5' color='info'>
            {`Last Updated: ${getUTCTime(
              currentChartPreviewData?.updated_at as string
            )}`}
          </MDTypography>
        </MDBox>
      </If>
      <If condition={!currentChartPreviewData.chart_title}>
        <FullPageLoader height='100%' />
      </If>
    </>
  );
};

export default ChartHeader;
